import { computed } from "@ember/object"
import Component from "@glimmer/component"
import type { Course, CourseCalendarDateDefault } from "@shared/models/course"
import type { RotationCalendarRotation } from "@shared/models/rotation-calendar"
import { formatCourseTimePart } from "cc-frontend/utils/course/times"
import styles from "./one-time.module.css"

interface Sig {
  Args: {
    course: Course
    courseDateDefaults: CourseCalendarDateDefault[]
    rotation: RotationCalendarRotation
    setStartTime: (courseDate: CourseCalendarDateDefault, e: InputEvent) => void
    setEndTime: (courseDate: CourseCalendarDateDefault, e: InputEvent) => void
  }
}

/** One rotation day's start and end time. Only days the class meets on are rendered. */
export default class OneTimeComponent extends Component<Sig> {
  readonly styles = styles

  @computed("args.courseDateDefaults.[]", "args.rotation.id")
  get courseDate(): CourseCalendarDateDefault {
    const ans = this.args.courseDateDefaults.find(
      (date) => date.attributes.rotationId === this.args.rotation.id,
    )
    if (!ans) {
      throw new Error(
        `CourseDateDefault not found for rotation ${this.args.rotation.id} (${this.args.rotation.title})`,
      )
    }
    return ans
  }

  @computed("courseDate.attributes.time")
  get timeParts(): { startStr: string; endStr: string } {
    const time = this.courseDate.attributes.time ?? null
    if (time === null) return { startStr: "", endStr: "" }
    return { startStr: formatCourseTimePart(time.start), endStr: formatCourseTimePart(time.end) }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Course::CreateEdit::NameAndMore::OneTime": typeof OneTimeComponent
  }
}
